/* eslint-disable jsx-a11y/anchor-is-valid */

import React, { useEffect, useState } from 'react'

import { TableView, useDebounce } from '../../../_metronic/layout/components/RhEALComponent'

const ZoneManagement: React.FC = () => {

  const [searchResult, setSearchResult] = useState<string>("");
  const [myLoading, setMyLoading] = useState<boolean>(false);
  const [zoneListData, setZoneListData] = useState<any[]>([])
  const [pageNumber, setPageNumber] = useState<number>(1)
  const [totalRecords, setTotalRecords] = useState<number>(0)

  const debounceVal = useDebounce(searchResult, 700);
  const limit = 8;
  useEffect(() => {
    getZoneList()
  }, [pageNumber, debounceVal])

  const getZoneList = () => {

    setMyLoading(true);

    const getMRObj = {
      method: "get_zone_list",
      order_by:'recent',
      page: pageNumber,
      limit: limit,
      searchZoneName: debounceVal,
    };
    fetch(`${process.env.REACT_APP_API_URL_MAIN}get_zone_list`, {
      method: "POST",
      headers: {},
      body: JSON.stringify(getMRObj),
    })
      .then((result) => {
        result.json().then((response) => {
          if (response.status === 1) {
            setZoneListData(response?.data);
            setTotalRecords(response?.total_records)
            setMyLoading(false);
          } else {
            setMyLoading(false);
          }
        });
      })
      .catch(() => {
        setMyLoading(false);
      });

  };


  return (
    <>
      <div className='col-12'>
        <TableView totalRecords={totalRecords} data={zoneListData} setSearchResult={setSearchResult} setPageNumber={setPageNumber} pageNumber={pageNumber} limit={limit} loading={myLoading} tableHeading={'Zone LIst'} th2={'Zone'} th3={'Submission Count'} />
      </div>
    </>
  )
}

export { ZoneManagement }
